exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.spin[data-v-183a351f] {\n  animation: rotate-183a351f 1s infinite linear;\n}\n@keyframes rotate-183a351f {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n.overflow-wrap-anywhere[data-v-183a351f] {\n  overflow-wrap: anywhere;\n}\n", ""]);

